export default "__VITE_ASSET__cdc2daf9__"